<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
import { GEOLOCATION } from '@/store/mutation-types'

export default {
  name: 'App',
  methods: {
    getMyLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.$store.commit(GEOLOCATION, {
              longitude: position.coords.longitude,
              latitude: position.coords.latitude,
              accuracy: position.coords.accuracy
            })
          },
          err => {
            console.error(err)
          }
        )
      }
    }
  },
  created () {
    this.$nextTick(() => {
      this.getMyLocation()
    })
  }
}
</script>
